import codeMap from './codeMap.json'

const to3Map = codeMap
const to2Map = Object.entries(codeMap).reduce((map, [key, value]) => {
  map[value] = key
  return map
}, {})

export const swapCountryCode = (code: string | null) => {
  if (!code) return null
  return code.length === 2 ? to3Map[code] : to2Map[code]
}

export const get3DigitCode = (code: string | null) => {
  if (!code) return null
  if (code.length === 3) return code
  return to3Map[code]
}
